var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3384834,23.7110588 L20.0001207,18.2990588 L14.6615166,23.7110588 C14.2917223,24.0856471 13.6805478,24.0974118 13.2962707,23.7371765 C12.9119935,23.3769412 12.8999245,22.7811765 13.2694775,22.4065882 L19.3039804,16.2889412 C19.485981,16.1042353 19.7374991,16 20.0001207,16 C20.2625009,16 20.514019,16.1042353 20.6960196,16.2889412 L26.7305225,22.4065882 C27.1000755,22.7811765 27.0880065,23.3769412 26.7037293,23.7371765 C26.5164183,23.9127059 26.275521,24 26.0346236,24 C25.7811745,24 25.5279668,23.9032941 25.3384834,23.7110588 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter-by-Original_v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.6-Filter-by-Sales-Rep",
    transform: "translate(-968.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(955.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon_up_arrow",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpArrow);
export default __webpack_public_path__ + "static/media/icon_up_arrow.714b5357.svg";
export { ForwardRef as ReactComponent };